import { isEqual, mapValues } from 'lodash';
import { getRatingsAverage } from './ratings-utils';
export const createRatingsWatcher = (store) => {
    return {
        onChange: (onRatingChange) => {
            let prevState = mapToExternalRatingState(getRatingsState(store.getState()));
            store.subscribe(() => {
                const state = mapToExternalRatingState(getRatingsState(store.getState()));
                if (!isEqual(state, prevState)) {
                    onRatingChange(state);
                    prevState = state;
                }
            });
        },
        getCurrent: () => mapToExternalRatingState(getRatingsState(store.getState())),
    };
};
const getRatingsState = (state) => {
    return mapValues(state.comments, (state) => state && 'ratings' in state ? state.ratings : undefined);
};
const mapToExternalRatingState = (ratingsState) => {
    return mapValues(ratingsState, (state) => state
        ? { type: 'READY', average: getRatingsAverage(state), total: state.total }
        : { type: 'NOT_READY' });
};
//# sourceMappingURL=ratings-watcher.js.map